import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import rotas from "services/rotas";
import FormCadastroConvenio from './FormCadastroConvenio';
import useToggle from "lib/useToggle";
import Loading from 'lib/loading';
import rest from "lib/rest";

const Convenios = () => {

  const colunas = [
    {
      dataField: 'convenio_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'convenio',
      text: 'Covênio',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'conv_cnpj',
      text: 'Cnpj',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'conv_dia_fechamento',
      text: 'Data Fechamento',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'conv_telefone',
      text: 'Telefone',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'conv_bloqueio',
      text: 'Bloqueado',
      headerStyle: { cursor: 'default' }
    }
  ];

  const { SearchBar }                 = Search
  const [data, setdata]               = useState([])
  const [loading, setLoading]         = useState(true)
  const [modal, setModal]             = useToggle(false)
  const [convenio_id, setConvenio_id] = useState('')

  const listaConvenios = () => {
    const retorno = rest.get(rotas.convenios);
    retorno.then(ret => {
      if (ret.success && ret.success === 'S' && ret.lista!=='' && ret.lista !== null){

        let lista = ret.lista

        for (let i = 0; i < lista.length; i++) {
          if (lista[i]['conv_bloqueio'] === 'N' ) {
            lista[i]['conv_bloqueio'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Não</span></div>
          }else{
            lista[i]['conv_bloqueio'] = <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Sim</span></div>
          }
        }
        setdata(lista)
      }
      setLoading(false);
    })
  }

  useEffect(() => {
    listaConvenios();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal===false){
      listaConvenios();
    }
  }, [modal])

  const showForm = (convenio_id) =>{
    setConvenio_id(convenio_id)
    setModal();
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <>
        <div className="content">
          <Container>
            <Row>
              <Col md="12" className="p-0">
                <Card>

                  <CardHeader>
                    <Row>
                      <Col>
                        <CardTitle>CADASTRO DE CONVÊNIOS</CardTitle>
                      </Col>
                    </Row>
                  </CardHeader>

                  <CardBody>
                    <Modal
                      key = 'modal01'
                      size='xl'
                      isOpen={modal}
                    >
                      <ModalHeader>Cadastro de Convênios</ModalHeader>
                      <FormCadastroConvenio
                        closeModal  = { setModal }
                        convenio_id = {convenio_id}
                      >
                      </FormCadastroConvenio>
                    </Modal>
                    <ToolkitProvider
                      search
                      keyField  = "convenio_id"
                      data      = {data}
                      columns   = {colunas}
                    >
                      {
                        props => (
                          <div>
                            <Container>
                              <Row>
                                <Col md="3">
                                  <Button
                                    className="m-0 w-100"
                                    color="primary"
                                    outline
                                    style={{ padding: '5px 20px' }}
                                    onClick={()=>{ showForm(0) }  }
                                  >
                                    <i className="fas fa-plus" />
                                    Cadastrar
                                  </Button>
                                </Col>

                                <Col md="9">
                                  <SearchBar
                                    placeholder="Buscar Convênios..."
                                    style={{ padding: '5px' }}
                                    {...props.searchProps}
                                  />
                                </Col>
                              </Row>
                            </Container>

                            <hr />

                            <BootstrapTable
                              // remote
                              striped
                              keyField          = 'convenio_id'
                              noDataIndication  = "Nenhum registro encontrado"
                              rowStyle          = {{ cursor: "pointer" }}
                              pagination        = {paginationFactory({
                                                    sizePerPage: 10,
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    showTotal: false,
                                                  })}
                              columns           = {colunas}
                              data              = {data}
                              rowEvents         = {{
                                                      onDoubleClick: (e, row, rowIndex) => {
                                                        showForm(row.convenio_id);
                                                      }
                                                  }}
                              {...props.baseProps}
                            />
                          </div>
                        )
                      }
                    </ToolkitProvider>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    )
  }

}

export default Convenios;